import * as React from "react";
import {Tab} from 'semantic-ui-react'
import {GlobalGeofenceList} from "./globalGeofences/GlobalGeofenceList";
import {GeostatusWorkbench} from "./geostatusWorkbench/GeostatusWorkbench";
import {GeoStatusDumpCleanerTab} from "./geoStatusDumpCleaner/GeoStatusDumpCleanerTab";
import OrsPlaygroundApp from "./orsPlayground/App";
import {clampTabIndex} from "../../context/TabSession";
import {DumpFileVisualizerTab} from "./dumpVisualizer/DumpFileVisualizerTab";


const panes = [
    {menuItem: 'GlobalGeofence', render: props => <Tab.Pane id='GlobalGeofenceList'><GlobalGeofenceList/></Tab.Pane>},
    {menuItem: 'Geostatus', render: props => <Tab.Pane id='Geostatus'><GeostatusWorkbench location={props.location} match={props.match}/></Tab.Pane>},
    {menuItem: 'GeoStatusDumpCleaner', render: () => <Tab.Pane id='GeoStatusDumpCleaner'><GeoStatusDumpCleanerTab/></Tab.Pane>},
    {menuItem: 'ORS Playground', render: () => <Tab.Pane id='OrsPlayground' style={{padding: 0, height: 'calc(100vh - 120px)'}}><OrsPlaygroundApp/></Tab.Pane>},
    {menuItem: '📂 Dump Visualizer', render: () => <Tab.Pane id='DumpVisualizer' style={{padding: '0 16px', overflowY: 'auto', maxHeight: 'calc(100vh - 100px)'}}><DumpFileVisualizerTab/></Tab.Pane>},
]

const GeostatusTabMenu = props => <Tab
    {...props = props}
    panes={panes}
    defaultActiveIndex={clampTabIndex(props.context.tabSession.geostatus, panes)}
    onTabChange={(_, data) => {
        props.context.setSingleTabSession("geostatus", data.activeIndex)
    }}
/>

export default GeostatusTabMenu